<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">To my own godchildren</p>
<p class="center">—Helena Allan, Edie Campbell, Cara Delevingne,<br/>Ned Dahl Donovan, lone Hunter Gordon,<br/>Willa Montagu Petty and Ewan Wotherspoon–</p>
<p class="center">who luckily in no way resemble<br/>the godchildren in this story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_ded_r1.vue?4faacc02